/* EcomverX checkout slot — managed by the EcomverX panel. */
;(function () {
  var s = document.createElement('script')
  s.src = 'https://checkout.payverx.com/payverx.js'
  s.async = true
  document.head.appendChild(s)
})()
